import { useSelector } from "react-redux";
import { CountryData } from "~/data/shippingCountries";
import { State } from "~/store";

export default function useCountry() {
  return useSelector<State, CountryData | undefined>((s) => s.countryData);
}
